<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_COMP_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.eprCode"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ERP_COMP_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.erpeprCode"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CORP_DSTG_NO')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.vatNo"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_LCL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.eprName"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_GLBL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.englishEprName"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRD_PSBL_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="selectBlock"
              :selected="searchFrame.blockFlag"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_CATG')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <cmp-vendor-category-select
              ref="selectCategory"
              :pageId="pageId"
              :selected="searchFrame.categorySelected"
            />
          </div>
        </div>
      </div>
      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_Reset"
          @click="onResetClick"
        >
          {{ $t('MSG_BTN_RESET') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_Scr"
          @click="onSearchClick"
        >
          {{ $t('MSG_BTN_SEARCH') }}
        </sui-button>
      </div>
      <sui-grid
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :multiselect="false"
        :sortable="false"
        :filterable="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="closePopup"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onApplyClick"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00011_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchFrame: {
        blockFlag: {
          key: '',
          label: '',
        },
        eprCode: '',
        erpeprCode: '',
        vatNo: '',
        eprName: '',
        englishEprName: '',
        categorySelected: {
          level1: {
            key: '',
            label: '',
          },
          level2: {
            key: '',
            label: '',
          },
          level3: {
            key: '',
            label: '',
          },
          level4: {
            key: '',
            label: '',
          },
          searchCategoryId: '',
        },
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_CONN_COMP_CD'),
        datafield: 'eprCode',
      }, {
        text: this.$t('MSG_TXT_ERP_COMP_CD'),
        datafield: 'erpeprCode',
      }, {
        text: this.$t('MSG_TXT_COMP_LCL_NM'),
        datafield: 'eprName',
      }, {
        text: this.$t('MSG_TXT_COMP_GLBL_NM'),
        datafield: 'englishEprName',
      }, {
        text: this.$t('MSG_TXT_CORP_DSTG_NO'),
        datafield: 'vatNo',
      }, {
        text: this.$t('MSG_TXT_CATG'),
        datafield: 'categoryString',
      }, {
        text: this.$t('MSG_TXT_TRD_PSBL_YN'),
        datafield: 'blockFlag',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'eprCode', map: 'eprCode' },
      { type: 'string', name: 'erpeprCode', map: 'erpeprCode' },
      { type: 'string', name: 'eprName', map: 'eprName' },
      { type: 'string', name: 'englishEprName', map: 'englishEprName' },
      { type: 'string', name: 'vatNo', map: 'vatNo' },
      { type: 'string', name: 'blockFlag', map: 'blockFlag' },
      { type: 'string', name: 'categoryString', map: 'categoryString' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          this.$refs.selectBlock.reset();
          this.$refs.selectCategory.reset();
        } else if (!utils.isEqual(key, 'categorySelected')) {
          this.searchFrame[key] = '';
        }
      });
    },
    getSearchData() {
      const data = {};
      const field = 'searchCategoryId';
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'blockFlag')) {
          switch (value.key) {
            case 'ALL':
              data[key] = value.key;
              break;
            case 'Y':
              data[key] = '';
              break;
            default:
              data[key] = 'X';
              break;
          }
        } else if (utils.isEqual(key, 'categorySelected')) {
          data[field] = value.searchCategoryId;
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    categoryLevelToString(list, level) {
      const levelList = [];
      const seperate = ', ';
      utils.forEach(list, data => {
        if (data.companyCategoryLevel === level) {
          levelList.push(data.companyCategoryName);
        }
      });
      return utils.join(levelList, seperate);
    },
    categoryListToString(list) {
      const categoryList = [];
      const seperate = ' > ';
      for (let i = 1; i < 5; i += 1) {
        const levelString = this.categoryLevelToString(list, i);
        if (!utils.isEmpty(levelString)) {
          categoryList.push(levelString);
        }
      }
      return utils.join(categoryList, seperate);
    },
    dataFormat(data) {
      const block = utils.isEmpty(data.blockFlag) ? 'Y' : 'N';
      return {
        blockFlag: block,
        categoryString: this.categoryListToString(data.vendorCategoryList),
      };
    },
    onSearchClick() {
      const searchData = this.getSearchData();
      http.request(this.pageId, 'DTS_CMY_00027', {
        query: searchData,
      }).then(res => {
        utils.forEach(res.data, data => {
          utils.assign(data, this.dataFormat(data));
        });
        this.dataset0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    closePopup() {
      this.$emit('searchAndCanelView');
    },
    onApplyClick() {
      const [index] = this.dataset0.getSelectedIndexes();
      const { eprCode } = this.dataset0.getRawData()[index];

      if (!utils.isEmpty(eprCode)) {
        this.$emit('searchAndCanelView', eprCode);
      } else {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CONN_COMP')));
      }
    },
  },
};
</script>
<style scoped>
</style>
